






















import { Component, Vue, Prop } from 'vue-property-decorator';
import { formatTimeStr } from '@/utils/other';
import { generateTemplateOptions } from '@/utils/todo';

type IModuleTemplateInfo = IModule.IResponse.IModuleTemplateInfo;
type ITodoTemplateInfo = IModule.IResponse.ITodoTemplateInfo;

const titleColumm = {
  slots: { title: 'todoTitle' },
  dataIndex: 'title',
  ellipsis: true,
  width: '20%',
};
const manDayColumn = {
  slots: { title: 'manDayTitle' },
  dataIndex: 'manDay',
  width: '10%',
  align: 'center',
  sorter: (a: ITodoTemplateInfo, b: ITodoTemplateInfo) => a.manDay - b.manDay,
};
const descriptionColumm = {
  slots: { title: 'descriptionTitle' },
  dataIndex: 'description',
  ellipsis: true,
  width: '20%',
};
@Component({
  filters: {
    formatTimeStr,
  },
})
export default class ModuleTemplateTodo extends Vue {
  @Prop({required: true}) private template!: IModuleTemplateInfo;
  private totalManDay = 0;

  get todos() {
    const todos = this.template.templateTodoList.map((todo, index) => ({id: index.toString(), ...todo}));
    this.calcTotalManDay(todos);
    return todos;
  }
  get columns() {
    const { typeOption, statusOption, settlementUnitOption } = generateTemplateOptions(this.todos);
    const typeColumn = {
      slots: { title: 'typeTitle' },
      dataIndex: 'typeName',
      scopedSlots: { customRender: 'typeId' },
      width: '12%',
      ellipsis: true,
      filters: typeOption,
      onFilter: (value: string, record: ITodoTemplateInfo) => {
        return record.typeId === value;
      },
    };
    const statusColumn = {
      slots: { title: 'statusTitle' },
      dataIndex: 'todoStatus',
      width: '10%',
      align: 'center',
      filters: statusOption,
      onFilter: (value: string, record: ITodoTemplateInfo) => record.todoStatus === value,
    };
    const settlementUnitColumn = {
      dataIndex: 'settlementConfigurationName',
      slots: { title: 'settlementUnitTitle' },
      width: '8%',
      align: 'center',
      filters: settlementUnitOption,
      onFilter: (value: string, record: ITodoTemplateInfo) => record.settlementConfigurationId === value,
    };
    return [
      titleColumm,
      typeColumn,
      statusColumn,
      manDayColumn,
      settlementUnitColumn,
      descriptionColumm,
    ];
  }
  private calcTotalManDay(todos: ITodoTemplateInfo[]) {
    const totalManDay = todos.reduce((total, todo) => {
      if (todo.todoStatus !== 'Closed') {
        return total + todo.manDay;
      }
      return total;
    }, 0);
    this.totalManDay = parseFloat(totalManDay.toFixed(2));
  }
  private handleTableChange(
    pagination: any,
    filters: any,
    sorter: any,
    data: {currentDataSource: ITodoTemplateInfo[]},
  ) {
    this.calcTotalManDay(data.currentDataSource);
  }
}
